import {Component, inject, OnInit, PLATFORM_ID} from '@angular/core';

import {MatSnackBar} from "@angular/material/snack-bar";
import {LoanService} from "../../services/loan.service";
import {LoanType} from "../../models/loan-type";
import {MatSlider, MatSliderThumb} from "@angular/material/slider";
import {FormsModule} from "@angular/forms";
import {zip} from "rxjs";
import {Router} from "@angular/router";
import {LoanApplicationSteps} from "../../models/loan-application-step/loan-application-steps";
import {isPlatformBrowser, NgClass} from "@angular/common";
import {LoanApplicationService} from "../../services/loan-application.service";
import {Loader} from "../../../core/components/loader/loader";
import {Currency} from "../../../core/services/currency";
import {getTranslation} from "../../../core/models/translatable-model-abstract";

@Component({
  selector: 'app-loan-slider',
  standalone: true,
  imports: [MatSlider, FormsModule, MatSliderThumb, NgClass, Loader],
  templateUrl: './loan-slider.component.html',
  styleUrl: './loan-slider.component.scss'
})
export class LoanSliderComponent implements OnInit{
  protected loanService = inject(LoanService);
  protected currencyService = inject(Currency);
  protected loanApplicationService = inject(LoanApplicationService);
  protected snackBar = inject(MatSnackBar);
  protected router = inject(Router);

  protected loanTypes: LoanType[] = [];
  protected selectedLoanType: LoanType | null | undefined = null;
  protected selectedPeriod: number = 0;
  protected selectedPrincipal: number = 0;
  protected currentDatetime: Date = new Date();
  protected loanAggregatedAmounts: any = {
    "principalDue": 0,
    "interestDue": 0,
    "failureFeeDue": 0,
    "totalAmountDue": 0,
    "annualPercentageRate": 0,
  };

  protected areApiCalculationsLoading: boolean = true;

  constructor() {
  }

  ngOnInit(): void {
    this.initApiDependentData();
  }

  executeApiCalculations() {
    this.areApiCalculationsLoading = true;
    this.loanService.initForParameters({
      loanType: this.selectedLoanType?.id ?? 1,
      principal: this.selectedPrincipal,
      period: this.selectedPeriod
    }).subscribe({
        next: resultJson => {
          this.loanAggregatedAmounts = resultJson;
          this.areApiCalculationsLoading = false;
        },
        error: err => {
          console.log(err);
        },
      }
    );
  }

  getSelectedPeriodLoanInstalmentsCount(): number {
    return Math.ceil(this.selectedPeriod / 30);
  }

  changeSelectedLoanType(loanTypeId: number): void {
    this.selectedLoanType = this.loanTypes.find(loanType => {
      return loanType.id == loanTypeId
    });

    if (this.selectedLoanType) {
      this.selectedPeriod = this.selectedLoanType.periodInit;
      this.selectedPrincipal = this.selectedLoanType.principalInit;
      this.executeApiCalculations();
    }
  }

  protected initApiDependentData(): void {
    let loanTypes$ = this.loanService.getAllLoanTypeFromApi();
    let systemDatetime$ = this.loanService.getSystemDateTime();

    zip(loanTypes$, systemDatetime$)
      .subscribe({
        next: ([loanTypes, systemDateTime]) => {
          this.loanTypes = loanTypes;
          this.currentDatetime = new Date(systemDateTime.currentDate);

          this.changeSelectedLoanType(this.loanTypes[1].id);
        },
        error: err => {
          if (isPlatformBrowser(PLATFORM_ID)) {
            this.snackBar.open('Грешка при инициализиране на типове кредити!', '×', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: 'error',
            });
            console.log(err);
          }
        },
      });
  }

  public startApplication() {
    this.loanApplicationService.setApplicationStepDataInStorage(LoanApplicationSteps.Parameters, {
        'loanType': this.selectedLoanType?.id ?? 0,
        'principal': this.selectedPrincipal,
        'period': this.selectedPeriod,
      }
    );
    this.router.navigate(['/loan-application/parameters']);
  }

  // getLoanInstalments(): Array<any> {
  //   let loanInstalments: any[] = [];
  //   if (this.selectedLoanType && this.selectedPrincipal && this.selectedPeriod) {
  //     let dayInterestCoefficient = parseFloat((this.selectedLoanType.interestRate / 100).toFixed(4));
  //     /*Apply promotion for small loans*/
  //     // if(this.customerLoansCount == 0 && this.loanType == 1 && this.period <= 30){
  //     // 	dayInterestCoefficient = 0;
  //     // }
  //     let period = this.selectedPeriod;
  //     let principal = this.selectedPrincipal;
  //     let loanInstalmentsCount = this.getSelectedPeriodLoanInstalmentsCount();
  //     const monthPrincipal = (loanInstalmentsCount == 1) ? principal : parseFloat((principal / loanInstalmentsCount).toFixed(2));
  //
  //     let paymentMaturityDate = new Date(this.currentDatetime.toDateString());
  //
  //     let paymentMaturityDateString;
  //     for (let i = 0; i < loanInstalmentsCount; i++) {
  //       if (period >= 30) {
  //         paymentMaturityDate.setDate(paymentMaturityDate.getDate() + 30);
  //       } else {
  //         paymentMaturityDate.setDate(paymentMaturityDate.getDate() + period);
  //       }
  //       let paymentAmount = monthPrincipal + monthPrincipal * dayInterestCoefficient * period;
  //
  //       period -= 30;
  //       principal -= monthPrincipal;
  //       paymentMaturityDateString = paymentMaturityDate.toISOString().slice(0, 10).replace(/-/g, '.');
  //       loanInstalments.push({
  //         maturityDate: paymentMaturityDateString,
  //         amount: parseFloat(paymentAmount.toFixed(2))
  //       });
  //     }
  //   }
  //
  //   return loanInstalments;
  // }
  // getTotalAmountDue(): number {
  //   let totalAmountDue = 0;
  //   this.getLoanInstalments().forEach((loanInstalment) => {
  //     totalAmountDue += loanInstalment?.amount;
  //   });
  //
  //   return totalAmountDue;
  // }

  // calculatePeriodMaximum(): number {
  //   let periodMaximum: number | null = 0;
  //   if (this.selectedLoanType?.periodMaximum) {
  //     periodMaximum = this.selectedLoanType.periodMaximum;
  //     if (this.selectedLoanType.constant == "EVEN_PRINCIPAL_PAYMENTS") {
  //       if (this.selectedPrincipal / 50 * 30 <= this.selectedLoanType.periodMaximum) {
  //         periodMaximum = this.selectedPrincipal / 50 * 30;
  //         if (this.selectedPeriod >= periodMaximum) {
  //           this.selectedPeriod = periodMaximum;
  //         }
  //       }
  //     }
  //   }
  //
  //   return periodMaximum;
  // }
  protected readonly getTranslation = getTranslation;
}
